/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable prefer-template */
const { useRef, useEffect } = require('react');

function IndeterminateCheckbox({ indeterminate, className = '', ...rest }) {
  const ref = useRef();

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className={className + ' cursor-pointer'}
      {...rest}
    />
  );
}
export default IndeterminateCheckbox;
